const AuthSectionHeading = ({ children }) => {
  const [leftText, rightText] =
    typeof children === "string" && children.includes(",")
      ? children.split(",").map((t) => t.trim())
      : [children, ""];

  return (
    <>
      <h4
        className={`text-lg font-semibold ${
          rightText ? "w-1/2" : "w-full"
        } mb-4 px-2`}
      >
        {leftText}
      </h4>
      {rightText && (
        <h4 className="text-lg font-semibold w-1/2 mb-4 px-2">{rightText}</h4>
      )}
    </>
  );
};

export default AuthSectionHeading;
